const logs = false; //window.jitDebug;
const adLoadingSemaphore = {};
const adLoaded = {};
let configuration = {};
let callbacks = {};
let countCheckSetup = 0;
let isSetupFinished = true;

const preparaContenidor = (containerId, sasId) => {
    let container = $('#' + containerId);
    if (container.length > 0) {
        container.empty();
        if (sasId !== '') {
            container.append($('<div id="sas_' + sasId + '" ></div>'));
        }
    }
};
const preparaContenidorBanner = (format, formatId) => {
    preparaContenidor('sas_container_' + format, formatId);
};
const preparaContenidorOutline = (format, formatId) => {
    let containerId = 'publi_' + format;
    if ($('#' + containerId).length === 0) {
        $(document.body).prepend($('<div id="' + containerId + '"></div>'));
    } else {
        if (format === 'FORMAT_BACKGROUND') {
            //En cas de ser una publicitat de background treiem classe bgbrand
            $('html').removeClass('bgbrand');
        }
    }
    preparaContenidor(containerId, formatId);
};

const isLoadingAd = (configuration) => {
    if (configuration && configuration.format) {
        return adLoadingSemaphore[configuration.format] === true;
    }
    return false;
};

const checkIsSetupFinished = () => {
    return new Promise((resolve) => {
        const checkSetup = function () {
            if (countCheckSetup > 20) {
                countCheckSetup = 0;
                resolve(false);
            } else {
                if (isSetupFinished) {
                    resolve(true);
                } else {
                    countCheckSetup = countCheckSetup + 1;
                    setTimeout(checkSetup, 1000);
                }
            }
        };
        checkSetup();
    });
};
const activeLoadingCallback = (container, uuid, inlineFormat, callbacks) => {
    let times = 0,
        callbackInterval,
        i,
        tagName,
        found = false;
    callbackInterval = setInterval(function () {
        if (inlineFormat) {
            let children = container.children();
            for (i = children.length - 1; i >= 0; i = i - 1) {
                tagName = children.eq(i).prop('tagName');
                if (tagName !== 'SCRIPT') {
                    if (children.eq(i).children().length > 0) {
                        found = true;
                    }
                }
            }
        } else {
            if (container.find('script').length > 1 || $('html').find('#jpx-wp-front-container')[0] !== undefined) {
                found = true;
            }
        }
        if (found === true) {
            clearInterval(callbackInterval);
            callbacks.onSuccess();
            callbacks.onComplete(uuid);
        } else {
            times = times + 1;
            if (times > 10) {
                clearInterval(callbackInterval);
                callbacks.onError();
                callbacks.onComplete();
            }
        }
    }, 1500);
};

const demanaPublicitat = async (portalId, seccioId, formatId, uuid, inlineFormat, callbacks) => {
    let sas_pageid, sas_formatid, container /*,sas_target, noad*/;
    container = $('#sas_' + formatId);
    if (container.length > 0) {
        container.empty();
        sas_pageid = portalId + '/' + seccioId;
        sas_formatid = formatId;
        if (logs) {
            console.log('Publicitat Ajax: SmartAdServerAjax(' + sas_pageid + ', ' + sas_formatid + ", '')");
        }
        const setupFinished = await checkIsSetupFinished();
        if (setupFinished) {
            window.sas.call('std', {
                siteId: portalId,
                pageId: seccioId,
                formatId: formatId,
                target: ''
            });
            activeLoadingCallback(container, uuid, inlineFormat, callbacks);
        }
    } else {
        callbacks.onError();
        callbacks.onComplete();
    }
};

const refrescaPublicitat = (publicitat, format) => {
    let formatId,
        portalId,
        seccioId,
        publiFormat = publicitat.format;

    portalId = publicitat.portalId;
    seccioId = publicitat.seccioId;
    formatId = publicitat.formatIds[format];

    callbacks = publicitat.callbacks || {};
    if (publicitat.inlineFormat === false) {
        preparaContenidorOutline(publiFormat, formatId);
    } else {
        preparaContenidorBanner(publiFormat, formatId);
    }
    adLoadingSemaphore[publiFormat] = true;
    demanaPublicitat(portalId, seccioId, formatId, publicitat.uuid, publicitat.inlineFormat, {
        onError: _.bind(function () {
            if (logs) {
                console.log('**************error loading ad: ' + publiFormat);
            }
            adLoaded[publiFormat] = false;
            $('.M-publicitat.smart_' + publiFormat).css('display', 'none');
            $('html')
                .removeClass('ad_' + publiFormat)
                .addClass('noad_' + publiFormat);
        }),
        onSuccess: _.bind(function () {
            if (logs) {
                console.log('*************success loading ad: ' + publiFormat);
            }
            adLoaded[publiFormat] = true;
            $('.M-publicitat.smart_' + publiFormat).css('display', 'inherit');
            $('html')
                .removeClass('noad_' + publiFormat)
                .addClass('ad_' + publiFormat);
        }),
        onComplete: _.bind(function (uuid) {
            adLoadingSemaphore[publiFormat] = false;
            $(document).trigger('publicitat', {
                device: format,
                format: publiFormat,
                loaded: adLoaded[publiFormat]
            });
            const onCompletePubliEvent = new CustomEvent('onCompletePublicitat', {
                detail: {
                    device: format,
                    format: publiFormat,
                    loaded: adLoaded[publiFormat],
                    formatId,
                    portalId,
                    seccioId,
                    uuid
                }
            });

            document.dispatchEvent(onCompletePubliEvent);
        })
    });
};

const refrescaPublicitatsPerFormat = () => {
    let actualFormat = window.JITPUBLI_TYPE_TO_KEY[window.jitpubliType];
    let publiFormat;
    if (configuration.times !== undefined) {
        configuration.times = configuration.times - 1;
    }
    if (configuration.times === undefined || configuration.times >= 0) {
        publiFormat = configuration.format;
        adLoadingSemaphore[publiFormat] = adLoadingSemaphore[publiFormat] || false;
        if (!isLoadingAd(configuration)) {
            refrescaPublicitat(configuration, actualFormat);
        }
    }
};

const initialize = (conf, adType) => {
    configuration = conf;
    refrescaPublicitatsPerFormat();
    if (adType === 'smart') {
        window.jitdevizr
            .register(JITPUBLI_TYPE.LARGE_PC, refrescaPublicitatsPerFormat)
            .register(JITPUBLI_TYPE.MEDIUM_PC, refrescaPublicitatsPerFormat)
            .register(JITPUBLI_TYPE.MEDIUM_TABLET, refrescaPublicitatsPerFormat)
            .register(JITPUBLI_TYPE.SMALL_TABLET, refrescaPublicitatsPerFormat)
            .register(JITPUBLI_TYPE.MICRO_MOBILE, refrescaPublicitatsPerFormat)
            .listen();
    }
};

const removeListeners = () => {
    try {
        jitdevizr
            .unregister(JITPUBLI_TYPE.LARGE_PC, refrescaPublicitatsPerFormat)
            .unregister(JITPUBLI_TYPE.MEDIUM_PC, refrescaPublicitatsPerFormat)
            .unregister(JITPUBLI_TYPE.MEDIUM_TABLET, refrescaPublicitatsPerFormat)
            .unregister(JITPUBLI_TYPE.SMALL_TABLET, refrescaPublicitatsPerFormat)
            .unregister(JITPUBLI_TYPE.MICRO_MOBILE, refrescaPublicitatsPerFormat);
    } catch (err) {
        console.error('publicitat: cannot remove listeners: ' + err);
    }
};

export { initialize, removeListeners };
